function moneyInput($filter) {
	return {
		restrict: "A",
		require: "ngModel",
		link: function(scope, element, attrs, ngModel) {
			let lastValidValue = null;

			ngModel.$formatters.push(function(value) {
				if(value != null) {
					lastValidValue = value;
					return $filter("number")(value, 2);
				}
				return "";
			});

			ngModel.$parsers.push(function(value) {
				const num = parseFloat(value.replace(/[^0-9.]/g, ""));
				if(isNaN(num)) {
					ngModel.$setViewValue($filter("number")(lastValidValue || 0, 2));
					ngModel.$render();
					return lastValidValue;
				}
				lastValidValue = num;
				return num;
			});

			element.on("blur", function() {
				if(ngModel.$modelValue != null) {
					ngModel.$viewValue = $filter("number")(ngModel.$modelValue, 2);
					ngModel.$render();
				}
			});

			element.on("focus", function() {
				if(ngModel.$modelValue != null) {
					ngModel.$viewValue = ngModel.$modelValue.toString();
					ngModel.$render();
				}
			});
		}
	};
}

export default angular
	.module("vesl.behaviors.money-input", [])
	.directive("moneyInput", moneyInput).name;
